import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Col, Row } from 'react-bootstrap';
import styles from './styles.css';

const blueColor = '#0097a9';
const lightGreyColor = '#DEE0E1';
const darkGreyColor = '#D1D3D5';
const arrayOfChartColors = [blueColor, lightGreyColor, darkGreyColor];

class RatingsDonutChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartOptions: {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent',
          height: '143',
          margin: [0, 0, 0, 0],
        },
        title: { text: '' },
        plotOptions: {
          pie: {
            dataLabels: { enabled: false },
            states: { hover: { enabled: false } },
          },
        },
        colors: arrayOfChartColors,
        series: [{
          type: 'pie',
          name: 'Ratings',
          innerSize: '75%',
          data: [
            { name: 'Negative', y: props.negative },
            { name: 'Neutral', y: props.neutral },
            { name: 'Positive', y: props.positive },
          ],
        }],
        credits: { enabled: false },
      },
    };
  }

  getChartOptions(ratingsSentiment) {
    const sentimentColorArray = _.clone(arrayOfChartColors);

    const sentimentChartOptions = _.cloneDeep(this.state.chartOptions);
    const indexOfSentimentSeries = _.findIndex(sentimentChartOptions.series[0].data, d => d.name === ratingsSentiment);
    if (indexOfSentimentSeries < 0) {
      return sentimentChartOptions; // there must be no ratings
    }
    if (ratingsSentiment === 'Neutral') { // blue needs to be middle color
      sentimentColorArray.unshift(sentimentColorArray.pop());
    } else if (ratingsSentiment === 'Positive') { // blue needs to be last
      sentimentColorArray.push(sentimentColorArray.shift());
    }
    sentimentChartOptions.series[0].data[indexOfSentimentSeries].selected = true;
    sentimentChartOptions.colors = sentimentColorArray;
    return sentimentChartOptions;
  }

  updateSeries = (selectedCategoryRatings) => {
    if (!selectedCategoryRatings.negative && !selectedCategoryRatings.neutral && !selectedCategoryRatings.positive) {
      this.setState({
        chartOptions: {
          series: [{
            data: [
              { name: 'No Ratings', y: 1, color: lightGreyColor },
            ],
            tooltip: { headerFormat: '<span style="font-size: 10px">No Ratings</span><br/>', pointFormat: '' },
          }],
        },
      });
    } else {
      this.setState({
        chartOptions: {
          series: [{
            data: [
              { name: 'Negative', y: selectedCategoryRatings.negative },
              { name: 'Neutral', y: selectedCategoryRatings.neutral },
              { name: 'Positive', y: selectedCategoryRatings.positive },
            ],
            tooltip: { headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
              pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>' },
          }],
        },
      });
    }
  }

  render = () => {
    const negativeChartOptions = this.getChartOptions('Negative');
    const neutralChartOptions = this.getChartOptions('Neutral');
    const positiveChartOptions = this.getChartOptions('Positive');
    const { negative, neutral, positive } = this.props;
    const totalRatings = negative + neutral + positive || 0;
    const negativePercent = totalRatings ? Math.round((negative / totalRatings) * 100) : 0;
    const neutralPercent = totalRatings ? Math.round((neutral / totalRatings) * 100) : 0;
    const positivePercent = totalRatings ? (100 - negativePercent - neutralPercent) : 0; // so they equal 100
    return (
      <Row>
        <Col xs={4} sm={4}>
          <div className={styles.negativeChart}>
            <HighchartsReact
              highcharts={Highcharts}
              options={negativeChartOptions}
            />
          </div>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{ `${totalRatings ? `${negativePercent}%` : 'N/A'}` }</div>
            <div className={styles.subtitle}>{ `${negative} Ratings` }</div>
          </div>
        </Col>
        <Col xs={4} sm={4}>
          <div className={styles.neutralChart}>
            <HighchartsReact
              highcharts={Highcharts}
              options={neutralChartOptions}
            />
          </div>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{ `${totalRatings ? `${neutralPercent}%` : 'N/A'}` }</div>
            <div className={styles.subtitle}>{ `${neutral} Ratings` }</div>
          </div>
        </Col>
        <Col xs={4} sm={4}>
          <div className={styles.positiveChart}>
            <HighchartsReact
              highcharts={Highcharts}
              options={positiveChartOptions}
            />
          </div>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{ `${totalRatings ? `${positivePercent}%` : 'N/A'}` }</div>
            <div className={styles.subtitle}>{ `${positive} Ratings` }</div>
          </div>
        </Col>
      </Row>
    );
  }
}

RatingsDonutChart.propTypes = {
  positive: PropTypes.number.isRequired,
  neutral: PropTypes.number.isRequired,
  negative: PropTypes.number.isRequired,
};

export default RatingsDonutChart;
